<template>
  <div
    @click="handleClose"
    class="fixed inset-0 z-99 w-full h-screen bg-black/25 sm:backdrop-blur-xs"
    v-if="modelValue"
  ></div>
  <Transition enter-active-class="slideInUp" leave-active-class="slideOutDown">
    <div
      v-if="modelValue"
      class="fixed sm:top-0 bottom-0 left-0 right-0 z-190 w-full h-auto bg-transparent flex md:items-center items-end justify-center p-0"
    >
      <div
        class="bg-white sm:rounded-t-2xl rounded-t-lg sm:rounded-b-2xl sm:border sm:border-gray-100 sm:shadow shadow-2xl max-h-svh flex flex-col"
        :class="sizes"
      >
        <div
          class="sm:flex hidden items-center justify-between sm:px-5 px-2.5 sm:py-4 py-2.5 border-b border-gray-100"
        >
          <div></div>
          <p
            class="lg:text-xl md:text-lg sm:text-base text-sm md:font-bold font-medium"
          >
            {{ title }}
          </p>
          <button
            :title="$t('common.close')"
            type="button"
            class="transition-all duration-300 cursor-pointer sm:size-10 sm:min-w-10 size-8 min-w-8 rounded-full flex items-center justify-center bg-gray-100 hover:bg-gray-300"
            @click.stop="handleClose"
          >
            <Icon name="heroicons:x-mark" size="18" />
          </button>
        </div>
        <div
          @click="handleClose"
          class="sm:hidden flex items-center justify-center py-1.5"
        >
          <div class="h-1 bg-gray-300 w-16 rounded-xs"></div>
        </div>
        <div
          class="transition-all duration-300 p-2.5 overflow-y-auto min-h-0"
          ref="modalContent"
        >
          <slot />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue: boolean;
    title?: string;
    sizes?: string;
  }>(),
  {
    sizes: "sm:w-auto w-full h-auto",
  },
);

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "close"): void;
}>();

const handleClose = () => {
  emit("update:modelValue", false);
  emit("close");
};
</script>
